<template lang="pug">
div
  el-card(
      shadow='hover'
      v-if="!isUsuarioExterno && exibeObs"
    ).card-collapse
    app-header-dados-processo(
      :showBotaoOpcoesHeader="false"
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow='hover').card-collapse
    app-divider(label="Dados da VTN: ", :addMarginTop="false")
    div.centerDados(v-if="dadosVtn")
      el-col(:span='8').flex
        app-display(label="Somatório dos Fatores de Redução:", :content="getValor(dadosVtn, 'somatorioDosConficientesFormatado') ? getValor(dadosVtn, 'somatorioDosConficientesFormatado') : '-' " :contentAlignRight="false")
        app-display(label="Valor do VTN Para Área em Uso:", :content="getValorNumerico(dadosVtn, 'municipio, valorReferencia').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor do VTN Para Área de Reserva Legal:", :content="getValorNumerico(dadosVtn, 'vtnAreaReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor Total do Imóvel:", :content="dadosVtn.valorFinalImovelFormatado" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Porcentagem Máxima Para Redução (%):", :content="getValor(dadosVtn, 'porcentagemMaximaReducaoFormatada')" :contentAlignRight="false")
        app-display(label="VTN: Para Área em Uso(R$/ha):", :content="getValorNumerico(dadosVtn, 'vtntAreaUso').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="VTN: Para Área de Reserva Legal(R$/ha)", :content="getValorNumerico(dadosVtn, 'vtntReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor Total do Imóvel a Vista (R$):", :content="dadosVtn.valorAVistaFormatado || dadosVtn.valorFinalImovelFormatado" :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Porcentagem Aplicável Para Redução:", :content="getValor(dadosVtn, 'percentualAplicadoFormatado')" :contentAlignRight="false")
        app-display(label="Valor do Imóvel em Relação a Área em Uso:", :content="getValorNumerico(dadosVtn, 'vtnAreaUso').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
        app-display(label="Valor do Imóvel em Relação a Área de Reserva Legal:", :content="getValorNumerico(dadosVtn, 'vtnReservaLegal').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })" :contentAlignRight="false")
  ConfirmarDados(
    :dadosVtn="dadosVtn"
    :processo="processo"
  )
  el-card(shadow='hover' v-if="!isGerenciar && escolheuExterno && !isCriado").card-collapse
    div.cardHeader
      b Formas de pagamento:
    div#line
    div.centerRadio
      el-radio-group.radio-group(
        :disabled="isVisualizar"
        name="Cônjuge possui certidão?",
        v-model="dadosVtn.formaPagamento"
      )
          el-radio.radio(label='PARCELADO') Pagamento parcelado
          el-radio.radio(label='A_VISTA') Pagamento à vista
    div.flexStart.margin10(v-if="dadosVtn.formaPagamento === 'PARCELADO'")
      div.flex
        span Período de carência (PC):
        el-select(
          :disabled="isVisualizar"
          @change="changeCarencia"
          v-model="dadosVtn.carencia"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="carencia in carencias",
            :key="carencia.id",
            :label="carencia.value",
            :value="carencia.id",
            @change="calcular(false)"
          )
      div.flex
        span Nº de parcelas anuais (n):
        el-select(
          :disabled="isVisualizar"
          @change="calcular(false)"
          v-model="dadosVtn.qntdParcelas"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="parcela in parcelasComputed",
            :key="parcela.id",
            :label="parcela.value",
            :value="parcela.id"
          )
    div.flex.margin10
      el-col(:span='9').flex
        app-display(label="Resumo", content="", :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Valor(R$)", content="", :contentAlignRight="false")
      el-col(:span='7').flex
        app-display(label="Data vencimento", content="", :contentAlignRight="false")
    div.flex.margin10(v-if="parcelasPagar", v-for="parcela in parcelasPagar")
      el-col(:span='9').flex
        app-display(:label="getLabel(parcela)", content="", :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(:label="parcela.valorFormatado", content="", :contentAlignRight="false")
      el-col(:span='7').flex
        app-display(:label="parcela.dataVencimentoFormatada", content="", :contentAlignRight="false")

  app-buttons-cadastro(
    v-if="!isVisualizar",
    :showButtonSalvar='false',
    :showButtonCancelar='!isResumo',
    :showButtonFinalizar='true',
    :isUltimoPasso='true'
    :isPrimeiroPasso='!isResumo',
    :isIntroPasso='false',
    @cancelar='cancelar',
    @finalizar='finalizar',
    @voltar='cancelar'
  )

</template>

<script>
import { mapActions } from 'vuex'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import TabelaAmortizacao from './components/TabelaAmortizacao.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
import AppModal from '@/components/AppModal'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import parcelas from './constants/parcelas'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import ConfirmarDados from './components/ConfirmarDados.vue'
import { cloneDeep } from 'lodash'

export default {

  components: {
    AppHeaderDadosProcesso,
    AppDivider,
    AppDisplay,
    AppModal,
    TabelaAmortizacao,
    AppButtonsCadastro,
    ConfirmarDados
  },

  mixins: [AppNotificacao],

  props: {
    processo: {
      type: Object,
      required: true
    },
    vtn: {
      type: Object,
      required: true
    },
    isUsuarioExterno: {
      type: Boolean,
      default: false
    },
    isGerenciar: {
      type: Boolean,
      default: false
    },
    isVisualizar: {
      type: Boolean,
      default: false
    },
    exibeObs: {
      type: Boolean,
      default: false,
      required: false
    },
    escolheuExterno: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data () {
    return {
      isCCR: false,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      dadosVtn: {
        carencia: 0,
        qntdParcelas: 0,
        valorFinalImovel: 0,
        formaPagamento: 'PARCELADO',
        isVtnSimulado: false,
        status: ''
      },
      carencias: [
        {
          id: 0,
          value: 'Sem carência'
        },
        {
          id: 1,
          value: '1 Ano'
        },
        {
          id: 2,
          value: '2 Anos'
        },
        {
          id: 3,
          value: '3 Anos'
        }
      ],
      isAVista: false,
      parcelas: [],
      dadosAmortizacao: [],
      showModal: false,
      dadosDetalhamento: {
        totalPago: '0,00',
        situacaoVtn: 'Em aberto',
        correcaoAnual: '0,00',
        saldoDevedor: '',
        saldoAposCarencia: '',
        prestacaoInicial: '',
        totalJuros: ''
      },
      carenciaSelect: 1,
      parcelasPagar: []
    }
  },

  computed: {
    parcelasComputed () {
      return this.parcelas.slice(0, this.parcelas.length - (this.carenciaSelect || 0))
    },
    formaPagamentoComputed () {
      return this.dadosVtn.formaPagamento === 'PARCELADO' ? 'Parcelado' : 'À vista'
    },
    isResumo () {
      return this.isUsuarioExterno && this.isVisualizar
    },
    isCalculando () {
      return this.dadosVtn.status === 'Criado' && !this.dadosVtn.formaPagamento
    },
    isCriado () {
      return this.dadosVtn.status === 'Criado' && !this.isUsuarioExterno
    }
  },

  watch: {
    'dadosVtn.formaPagamento': {
      async handler (oldVal, newVal) {
        if (oldVal === 'A_VISTA') {
          this.calcular()
          this.dadosDetalhamento.totalJuros = 0
          this.isAVista = true
        } else {
          this.calcular()
          this.isAVista = false
        }
      }}
  },

  async created () {
    this.dadosVtn = await this.findVtnById(this.vtn?.id)
    this.dadosVtn = {
      ...this.dadosVtn,
      isVtnSimulado: false,
      formaPagamento: this.dadosVtn.formaPagamento === null ? 'PARCELADO' : this.dadosVtn.formaPagamento,
      carencia: this.dadosVtn.carencia === null ? 0 : this.dadosVtn.carencia,
      qntdParcelas: this.dadosVtn.qntdParcelas === null ? 1 : this.dadosVtn.qntdParcelas
    }
    this.parcelas = cloneDeep(parcelas.parcelas)
    this.calcular(false)
    this.changeCarencia()
  },

  methods: {
    ...mapActions({
      findVtnById: 'vtn/findVtnById',
      calcularVtn: 'vtn/calcularVtn',
      updateVtn: 'vtn/updateVtn',
      confirmarDadosVTNRR: 'vtn/confirmarDadosVTNRR'
    }),

    getFormaPagamento () {
      return this.dadosVtn.formaPagamento === null || this.dadosVtn.formaPagamento === 'null' ? 'PARCELADO' : this.dadosVtn.formaPagamento.codigo
    },

    changeCarencia () {
      this.carenciaSelect = this.dadosVtn.carencia
      this.calcular(false)
    },

    async calcular (isFinalizar = false) {
      this.dadosVtn.vtn = this.vtn
      const dadosVtn = {
        ...this.dadosVtn,
        coeficientAngular: null,
        coeficienteLinear: null,
        formaPagamento: this.getFormaPagamento(),
        vtn: {
          ...this.dadosVtn.vtn,
          coeficientAngular: null,
          coeficienteLinear: null,
          formaPagamento: this.getFormaPagamento()
        },
        isFinalizar: isFinalizar
      }
      let dados = await this.calcularVtn(dadosVtn)
      this.parcelasPagar = dados
      if (isFinalizar) {
        this.dadosVtn.status = 'AGUARDANDO_VALIDACAO'
      }
    },

    closeModal () {
      this.showModal = false
    },

    openModal () {
      this.showModal = true
    },

    cancelar () {
      this.$router.back()
    },

    goToListagem () {
      this.$router.back()
    },

    async atualizarVtn (dados) {
      const dadosUpdate = {
        ...this.dadosVtn,
        saldoDevedor: dados[0].saldoDevedor,
        qntdParcelas: this.dadosVtn.qntdParcelas,
        carencia: this.dadosVtn.carencia,
        valorEntrada: 0,
        dataInicial: dados[1].dataVencimento,
        totalJuros: dados.map(dado => { return dado.juros }).reduce((previousValue, currentValue) => previousValue + currentValue, 0).toFixed(2),
        totalPago: 0,
        formaPagamento: this.dadosVtn.formaPagamento,
        municipio: this.processo.municipios[0],
        qtdModuloFiscal: this.dadosVtn.nModuloFiscal,
        moduloFiscal: this.dadosVtn.municipio.mf,
        valorFinalAposCarencia: dados[0].saldoDevedor,
        status: this.dadosVtn.status
      }
      await this.updateVtn(dadosUpdate)
    },

    async finalizar () {
      await this.calcular(true)
      this.dadosVtn = {
        ...this.dadosVtn,
        parcelasAp: this.parcelasPagar,
        municipio: this.vtn.municipio,
        qtdModuloFiscal: this.dadosVtn.nModuloFiscal,
        moduloFiscal: this.dadosVtn.municipio.mf,
        areaReservaLegalCerrado: this.processo.dadosCadastro.dados.cadastro.imovel.areaReservaLegalCerrado,
        areaReservaLegalFloresta: this.processo.dadosCadastro.dados.cadastro.imovel.areaReservaLegalFloresta
      }
      await this.updateVtn(this.dadosVtn)
      await this.confirmarDadosVTNRR(this.processo.id)
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.mensagemEscolhaPagamento()
      )
      this.goToListagem()
    },

    mensagemEscolhaPagamento () {
      return 'Forma de pagamento escolhida com sucesso!'
    },

    formatarMoeda (valor) {
      const valorNormalizado = valor * 1
      return valorNormalizado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    },
    voltar () {
      this.$router.push({
        name: 'GESTAO_VTN'
      })
    },
    getLabel (value) {
      return value?.numero === 0 ? 'Valor do VTN' : `Parcela ${value.numero}`
    },
    getValorNumerico (value, campo, produto = 1) {
      if (campo.split(',').length > 0) {
        const campos = campo.split(',')
        return value[campos[0]] && value[campos[0]][campos[1]] ? value[campos[0]][campos[1]] * produto : 0
      }
      return value[campo] ? value[campo] * produto : 0
    },
    getValor (object, value) {
      return object[value] ? object[value] : ' - '
    }
  }
}
</script>

<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 20px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.centerRadio {
  display: flex;
  justify-content: center;
  margin-top: 2%;
  gap: 3%;
}

.centerDados {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 3%;
}

.margin-top {
  margin-top: 5%;
}

.flexStart {
  display: flex;
  margin-top: 5%;
  justify-content: flex-start;

  .flex {
    flex: 1;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
  }
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buttons {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 20px 10px;
}

.margin10 {
  margin: 20px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/VisualizarVtnAP.vue